import { Grid } from "@mui/material";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxTypography from "@rf-l1/MxTypography";

const Mon5Template = () => {
  return (
    <Grid container item xs={12}>
      <MxTypography
        color="primary.main"
        variant="caption"
        fontWeight={500}
        sx={{ whiteSpace: "pre-line" }}
      >
        {`⦿ Estatus Jurídico
  
          El estatus jurídico de una propiedad se refiere a la situación legal de la misma. Esto incluye la verificación de que la propiedad esté libre de gravámenes, hipotecas, litigios u otras restricciones legales que puedan afectar su venta o uso. Es esencial asegurarse de que toda la documentación esté en orden y que la propiedad cumpla con todas las regulaciones legales antes de proceder con cualquier transacción.`}
      </MxTypography>
      <MxButton2
        variant="text"
        textColor="primary.main"
        testId="view-manual-button"
        sx={{
          my: 2,
          fontSize: "0.8rem",
          padding: "0",
          textTransform: "none",
          textDecoration: "underline"
        }}
        onClick={() => {
          window.open("/pdf_guide/manual_alertas_registrales.pdf", "_blank");
        }}
      >
        * Ver manual de Alertas Registrales
      </MxButton2>

      <MxTypography
        color="primary.main"
        variant="caption"
        fontWeight={500}
        sx={{ whiteSpace: "pre-line" }}
      >
        {`⦿ Previo MITUR
  
      Para proyectos turísticos, es indispensable obtener la aprobación previa del Ministerio de Turismo (MITUR). Este paso garantiza que el proyecto cumple con los estándares y regulaciones del sector turístico, esencial para proyectos que buscan atraer turismo internacional y local. La ley específica que regula esta aprobación es la Ley Sectorial de Turismo, decreto 540-09. No obtener esta aprobación puede limitar significativamente el potencial comercial del proyecto, además de exponer a los desarrolladores a sanciones por parte de autoridades turísticas.
      
      El MITUR evalúa aspectos como el impacto del proyecto en el turismo local, la infraestructura propuesta y la sostenibilidad del desarrollo. Una aprobación previa de MITUR no solo facilita el proceso de desarrollo sino que también puede proporcionar beneficios fiscales y otros incentivos. Ignorar este paso puede cerrar las puertas a estos beneficios y poner en riesgo la viabilidad comercial del proyecto.
      `}
      </MxTypography>
    </Grid>
  );
};
export default Mon5Template;
